import React from 'react';
import { useI18n } from '../../i18n/I18nProvider';
import { useSession } from '../../session/SessionProvider';
import { PageHeader } from '../../ui';
import BrandingEditor from '../../features/BrandingEditor';

export default function BrandingPage() {
  const { t } = useI18n();
  const { company } = useSession();
  return (
    <>
      <PageHeader title={t('branding.title')} description={t('branding.subtitle')} />
      <BrandingEditor tenantId={company.id} companyName={company.name} />
    </>
  );
}
